import React from 'react'
import './ScoutFeedbackIndicator.css'

export interface ScoutFeedbackIndicatorProps {
  /** Pulsiert, wenn ein Feedback-Prompt ansteht. Bei false wird nichts gerendert. */
  active: boolean
  /** Zusaetzliche CSS-Klasse. */
  className?: string
}

/**
 * Pulse-Ring am Scout-Floating-Button, wenn ein Feedback-Prompt ansteht
 * (Spec PROJ-Feedback-Prompt-System.md Abschnitt 3 + 5, F-4 / Bundle #7268).
 *
 * Reine CSS-Animation (`@keyframes`), respektiert `prefers-reduced-motion`
 * (dann statischer Ring statt Puls). Bewusst KEIN Zahlen-Badge — ein langsamer,
 * einladender Ring (~3 s). Dekorativ => `aria-hidden`.
 */
export const ScoutFeedbackIndicator: React.FC<ScoutFeedbackIndicatorProps> = ({
  active,
  className = '',
}) => {
  if (!active) return null
  const classes = ['scout-feedback-pulse', className].filter(Boolean).join(' ')
  return <span className={classes} aria-hidden="true" />
}

export default ScoutFeedbackIndicator
